module.exports = __webpack_public_path__ + "static/media/injures-icon.30bd0511.svg";